import { createImage } from 'tests/utils';
import type { WidgetTeaserStandardProps } from 'types/cms-teaser';

const widgetTeaserData: WidgetTeaserStandardProps = {
  model: {
    fields: {
      title: 'Widget Teaser Standard',
    },
  },
  items: [
    {
      model: {
        id: '101',
        image: createImage({
          baseUrl: 'https://picsum.photos/800/450',
          filename: 'page23_robot',
        }),
        fields: {
          subtitle: 'Cras et lorem non',
          title: 'Sagittis in erat. Cras et lorem non ipsum bibendum fermentum eleifend a orci. ',
        },
        url: 'https://dummyUrl.com',
        hasVideo: false,
      },
      type: 'storyline',
    },
    {
      model: {
        id: '102',
        image: createImage({
          baseUrl: 'https://picsum.photos/800/450',
          filename: 'page23_robot',
        }),
        fields: {
          subtitle: 'Cras et lorem non',
          title: 'Sagittis in erat. Cras et lorem non ipsum bibendum fermentum eleifend a orci. ',
        },
        url: 'https://dummyUrl.com',
        hasVideo: false,
      },
      type: 'storyline',
    },
    {
      model: {
        id: '103',
        image: createImage({
          baseUrl: 'https://picsum.photos/800/450',
          filename: 'page23_robot',
        }),
        fields: {
          subtitle: 'Cras et lorem non',
          title: 'Sagittis in erat. Cras et lorem non ipsum bibendum fermentum eleifend a orci. ',
        },
        url: 'https://dummyUrl.com',
        hasVideo: false,
      },
      type: 'storyline',
    },
    {
      model: {
        id: '104',
        image: createImage({
          baseUrl: 'https://picsum.photos/800/450',
          filename: 'page23_robot',
        }),
        fields: {
          subtitle: 'Cras et lorem non',
          title: 'Sagittis in erat. Cras et lorem non ipsum bibendum fermentum eleifend a orci. ',
        },
        url: 'https://dummyUrl.com',
        hasVideo: false,
      },
      type: 'storyline',
    },
    {
      model: {
        id: '105',
        image: createImage({
          baseUrl: 'https://picsum.photos/800/450',
          filename: 'page23_robot',
        }),
        fields: {
          subtitle: 'Cras et lorem non',
          title: 'Sagittis in erat. Cras et lorem non ipsum bibendum fermentum eleifend a orci. ',
        },
        url: 'https://dummyUrl.com',
        hasVideo: false,
      },
      type: 'storyline',
    },
  ],
};

export default widgetTeaserData;
